import { useQuery } from "@tanstack/react-query";
import PageHeader from "@/components/common/PageHeader";
import StatCard from "@/components/common/StatCard";
import { analyticsService } from "@/services/analytics.service";

function DashboardPage() {
  const { data, isLoading } = useQuery({
    queryKey: ["admin-analytics-overview"],
    queryFn: () => analyticsService.getOverview(),
  });

  const stats = [
    {
      label: "Active tenants",
      value: isLoading ? "..." : String(data?.activeTenants ?? 0),
    },
    {
      label: "Monthly revenue",
      value: isLoading
        ? "..."
        : `₹${(data?.monthlyRecurringRevenue ?? 0).toFixed(0)}`,
    },
    {
      label: "Open tickets",
      value: isLoading ? "..." : String(data?.openTickets ?? 0),
    },
    {
      label: "Trials this week",
      value: isLoading ? "..." : String(data?.trialsThisWeek ?? 0),
    },
  ];
  return (
    <div className="space-y-8">
      <PageHeader
        title="Platform overview"
        subtitle="Monitor tenant growth, revenue, and support activity."
      />

      <div className="grid gap-6 sm:grid-cols-2 xl:grid-cols-4">
        {stats.map((stat) => (
          <StatCard key={stat.label} {...stat} />
        ))}
      </div>

      <section className="rounded-3xl border border-slate-200 bg-white p-8 shadow-sm">
        <h3 className="text-lg font-semibold text-slate-900">
          Platform highlights
        </h3>
        <p className="mt-4 text-sm text-slate-600">
          Use the analytics page for deeper revenue and subscription insights.
        </p>
      </section>
    </div>
  );
}

export default DashboardPage;
